import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

/**
 * 明細列 RWD 小標：預設僅在 `< @3xl/form-section` 堆疊時顯示。
 * 大螢幕靠 LINE_HEADER 表頭；有錯時字色變紅。
 * 可傳 `className` 覆寫隱藏斷點（例如包裝 list 用 `@xl/pkg:hidden`）。
 */
const ListFieldMobileLabel = ({
  children,
  hasError = false,
  className,
}) => {
  return (
    <p
      className={cn(
        '@3xl/form-section:hidden text-xs',
        hasError ? 'text-red-500' : 'text-gray-500',
        className,
      )}
    >
      {children}
    </p>
  );
};

ListFieldMobileLabel.propTypes = {
  children: PropTypes.node.isRequired,
  hasError: PropTypes.bool,
  className: PropTypes.string,
};

export default ListFieldMobileLabel;
